export enum FeatureTypes {
  AppointmentDetailsIframe = 'APPT_DTLS_V2',
}
